<template>
  <validation-observer v-if="enabled" v-slot="{ invalid }">
    <proa-modal
      :modal="modal"
      :title="$t('pages.management.sharewindSettings.inviteNewMember')"
      @close="onClose"
    >
      <div class="h-100 d-flex flex-column" v-if="newInviteUser">
        <validation-provider
          :name="$t('models.user.attributes.email')"
          rules="required|email"
          v-slot="{ errors }"
        >
          <proa-input-group
            :label="$t('models.user.attributes.email')"
            :invalidFeedback="validateErrors && validateErrors.email ? validateErrors.email : errors[0]">
            <template slot="input">
              <proa-input
                v-model="newInviteUser.email"
                type="text"
                dark
              />
            </template>
          </proa-input-group>
        </validation-provider>
        <proa-input-group :label="$t('models.user.attributes.role')">
          <template slot="input">
            <proa-select
              v-model="newInviteUser.roleId"
              :options="roleOptions"
            />
          </template>
        </proa-input-group>
      </div>
      <template slot="footer">
        <proa-button
          @click.native="onClose"
          :disabled="postInviteUserRequesting"
          class="default-button-width mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="requestInviteUser"
          :disabled="invalid"
          :loading="postInviteUserRequesting"
          class="default-button-width"
          variant="primary"
        >
          {{ $t('common.invite') }}
        </proa-button>
      </template>
    </proa-modal>
  </validation-observer>
  <proa-modal
    v-else
    :modal="modal"
    :title="$t('pages.management.sharewindSettings.inviteNewMember')"
    @close="onClose"
  >
    <proa-heading sub>{{ $t('pages.management.reachedMaxUsersInOrganization') }}</proa-heading>
  </proa-modal>
</template>

<script>
import i18n from '@/i18n'
import { mapGetters, mapActions } from 'vuex'
import InviteUser from '@/store/models/admin/InviteUser'
import Role from '@/store/models/Role'
import Organization from '@/store/models/Organization'

export default {
  name: 'NewInviteUserModal',
  props: {
    modal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    enabled: function() { return this.currentLicensedPlan.maxUsers > this.currentOrganization.currentSeats },
    roleOptions: function() {
      return Role.all().filter((role) => {
        return role.roleType !== 'temporaryGuest'
      }).map((role) => {
        return {
          label: i18n.tc(`common.roleType.${role.roleType}`),
          value: role.id
        }
      })
    },
    ...mapGetters({
      httpError: 'httpError',
      currentOrganization: 'auth/currentOrganization',
      currentLicensedPlan: 'auth/currentLicensedPlan'
    })
  },
  data() {
    return {
      newInviteUser: null,
      postInviteUserRequesting: false,
      validateErrors: null
    }
  },
  methods: {
    onClose: function() {
      if (this.postInviteUserRequesting) return
      this.$emit('close')
    },
    async requestInviteUser() {
      this.postInviteUserRequesting = true
      await this.apiPostInviteUser(this.newInviteUser)
      this.postInviteUserRequesting = false
      if (this.httpError) {
        if (this.httpError.response.data.errors) {
          this.validateErrors = Object.fromEntries(
            Object.entries(this.httpError.response.data.errors).map((array) => {
              return [
                array[0],
                i18n.tc(`models.user.attributes.${array[0]}`) + array[1][0]
              ]
            })
          )
        }
        return
      }
      Organization.update({
        id: this.currentOrganization.id,
        currentSeats: this.currentOrganization.currentSeats + 1
      })
      this.$emit('invited')
    },
    ...mapActions({
      apiPostInviteUser: 'entities/inviteUsers/create'
    })
  },
  watch: {
    modal: function(value) {
      if (value) {
        this.newInviteUser = InviteUser.skeleton()
        this.validateErrors = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.user-header {
  padding: 20px 35px;
  min-height: 102px;

  @include mq(md) {
    padding: 0;
    margin-bottom: 40px;
  }
  .avatar-wrapper {
    margin: 0 10px 0 0;

    @include mq(md) {
      margin: 40px 20px 40px 40px;
    }

    img {
      width: 60px !important;
      height: 60px !important;

      @include mq(md) {
        width: 80px !important;
        height: 80px !important;
      }
    }
  }

  .info-assets-wrapper {
    .user-information-wrapper, .assets-wrapper {
      margin-top: 0;

      @include mq(md) {
        margin-top: 40px;
      }
    }

    .assets-wrapper {
      flex-grow: 1;
      text-align: left;
      margin-top: 10px;
      padding-right: 0;

      @include mq(md) {
        text-align: right;
        margin-top: 40px;
        padding-right: 40px;
      }
    }
  }
}
</style>
